import React, {useEffect} from "react"
// import PropTypes from "prop-types"
import { useStaticQuery, graphql, Link } from "gatsby"


import Clock from "../components/clock"

let serviceImagesPreloaded = false
let casestudyImagesPreloaded = false

const handleLinkClick = (e) => {
  // trigger handleHamburgerClick
  var hamburger = document.getElementById("hamburger");
  // hamburger.classList.toggle("overlay-visible");
  hamburger.click();
  
  // close the menus
  document.getElementById("sub-menu-service").style.display = 'none';
  document.getElementById("sub-menu-casestudy").style.display = 'none';
  document.querySelector(".menu-item-service").classList.remove('selected');
  document.querySelector(".menu-item-casestudy").classList.remove('selected');
  document.querySelector('.scrolly-menu').scrollTo({top: 0, behavior: 'instant'});
};

const positionSubMenu =(className) => {

  // and position it
  let isMobile = window.getComputedStyle(document.querySelector('.mobile-nav-footer')).display === "block";
  let elementHeight = document.querySelector('.menu-main li.selected').offsetHeight;
  let containerWidth = document.querySelector('.overlay-nav-scrolly').offsetWidth;
  let containerHeight = document.querySelector('.overlay-nav-scrolly').offsetHeight;
  let fadedHeight = containerHeight * 0.45; // top and bottom are 20% and 25% covered
  let visibleHeight = containerHeight - fadedHeight;
  let visibleTop = containerHeight * 0.22;
  let elementOffsetTop = document.querySelector('.menu-main li.selected').offsetTop;
  // console.log({elementHeight});
  // console.log({containerHeight});
  // console.log({fadedHeight});
  // console.log({visibleHeight});
  // console.log({visibleTop});
  // console.log({elementOffsetTop});
  // taller (eg mobile)
  if (isMobile || (elementHeight > visibleHeight)) {
    // console.log('taller (eg mobile)');
    let newTop = elementOffsetTop - visibleTop;
    // console.log({newTop});
    document.querySelector('.scrolly-menu').scrollTo({top: newTop, behavior: 'instant'});
  }
  else {
    // smaller (eg desktop)
    // console.log('smaller (eg desktop)')
    // let newTop = visibleTop - (elementHeight / 2);
    let newTop = elementOffsetTop - visibleTop - (elementHeight / 2);
    // console.log({newTop});
    document.querySelector('.scrolly-menu').scrollTo({top: newTop, behavior: 'instant'});
  }
}

const handleServiceClick = (e) => {
  // let scrollydisplay = 'block'
  // if (window.innerWidth > 768) {
  //   scrollydisplay = 'grid'
  // }
  if (document.querySelector(".menu-item-service").classList.contains('selected')) {
    // close it
    document.getElementById("sub-menu-service").style.display = 'none';
    document.getElementById("sub-menu-casestudy").style.display = 'none';
    document.querySelector(".menu-item-service").classList.remove('selected');
    document.querySelector(".menu-item-casestudy").classList.remove('selected');
    document.querySelector('.scrolly-menu').scrollTo({top: 0, behavior: 'instant'});
  }
  else {
    // open it
    document.getElementById("sub-menu-service").style.display = 'flex';
    document.getElementById("sub-menu-casestudy").style.display = 'none';
    document.querySelector(".menu-item-service").classList.add('selected');
    document.querySelector(".menu-item-casestudy").classList.remove('selected');

    // and position it
    positionSubMenu('service');

    // preload images
    if (!serviceImagesPreloaded) {
      let links = document.querySelectorAll("#sub-menu-service li a");
      links.forEach(function(link) {
        if (link.dataset.image) {
          // console.log(link.dataset.image)
          let imageUrl = link.dataset.image + '?fm=jpg&q=50&w=1280'
          const img = new Image();
          img.src = imageUrl;
        }
      });
      serviceImagesPreloaded = true;
    }

  }
  e.preventDefault();
}

const handleCaseStudyClick = (e) => {
  let scrollydisplay = 'block'
  if (window.innerWidth > 768) {
    scrollydisplay = 'flex'
  }
  if (document.querySelector(".menu-item-casestudy").classList.contains('selected')) {
    document.getElementById("sub-menu-service").style.display = 'none';
    document.getElementById("sub-menu-casestudy").style.display = 'none';
    document.querySelector(".menu-item-service").classList.remove('selected');
    document.querySelector(".menu-item-casestudy").classList.remove('selected');
    document.querySelector('.scrolly-menu').scrollTo({top: 0, behavior: 'instant'});
  }
  else {
    // open it
    document.getElementById("sub-menu-service").style.display = 'none';
    document.getElementById("sub-menu-casestudy").style.display = 'flex';
    document.querySelector(".menu-item-service").classList.remove('selected');
    document.querySelector(".menu-item-casestudy").classList.add('selected');

    // and position it
    positionSubMenu('casestudy');

    // preload images
    if (!serviceImagesPreloaded) {
      let links = document.querySelectorAll("#sub-menu-casestudy li a");
      links.forEach(function(link) {
        if (link.dataset.image) {
          // console.log(link.dataset.image)
          let imageUrl = link.dataset.image + '?fm=jpg&q=50&w=1280'

            // if mobile?
            if (window.innerWidth < 768) {
              imageUrl = link.dataset.mobileImage
            }
            
          const img = new Image();
          img.src = imageUrl;
        }
      });
      serviceImagesPreloaded = true;
    }

  }
  e.preventDefault();
}

const handleclearBackground = (e) => {
  // let backgroundImage = 'linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8))';
  // let backgroundImage = 'url(/images/footer.svg)';
  // document.querySelector('.overlay-nav-scrolly').style.backgroundImage = backgroundImage;
  // document.querySelector('.overlay-nav-scrolly').style.backgroundPosition = "50% 530px";
  let backgroundImage = 'none';
  document.querySelector('.overlay-nav-scrolly').style.backgroundImage = backgroundImage;
}

const handleLinkMouseOver = (e) => {
  // console.log(e.target.dataset.image)
  // document.getElementById("overlay-nav-image").src = e.target.dataset.image;
  // document.getElementById("overlay-nav-image").style.opacity = '1.0';
  // document.getElementById("overlay-nav-image").style.marginRight = '-40px';

  // console.log(e.target.dataset.image)
  let imageUrl = e.target.dataset.image

  // if mobile?
  if (window.innerWidth < 768) {
    imageUrl = e.target.dataset.mobileImage
  }

  imageUrl += '?fm=jpg&q=50&w=1280'
  let backgroundImage = 'linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url(' + imageUrl + ')';
  // document.querySelector('.overlay-nav-scrolly').style.backgroundImage = backgroundImage;

  const img = new Image();
  img.src = imageUrl;
  img.onload = function(){
    document.querySelector('.overlay-nav-scrolly').style.backgroundImage = backgroundImage;
    document.querySelector('.overlay-nav-scrolly').style.backgroundPosition = "center center";
  };
}

const handleLinkMouseOut = (e) => {
  // document.getElementById("overlay-nav-image").src = '/images/placeholders/hero_placeholder.png';
  // document.getElementById("overlay-nav-image").style.opacity = '0.0';
  // let backgroundImage = 'linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8))';
  // let backgroundImage = 'url(/images/footer.svg)';
  // document.querySelector('.overlay-nav-scrolly').style.backgroundImage = backgroundImage;
  // document.querySelector('.overlay-nav-scrolly').style.backgroundPosition = "50% 530px";
  let backgroundImage = 'none';
  document.querySelector('.overlay-nav-scrolly').style.backgroundImage = backgroundImage;
}

const OverlayNavScrolly = () => {

  React.useEffect(() => {
    updateOverlayNavScrolly();
    window.addEventListener("load", updateOverlayNavScrolly);
    window.addEventListener("resize", updateOverlayNavScrolly);
  });
  
  const updateOverlayNavScrolly = () => {
    // console.log('updateOverlayNavScrolly')

    // hide submenus
    document.getElementById("sub-menu-service").style.display = 'none';
    document.getElementById("sub-menu-casestudy").style.display = 'none';

    // center vertically on large screens
    let isMobile = window.getComputedStyle(document.querySelector('.mobile-nav-footer')).display === "block";
    if (!isMobile) {
      // console.log('center vertically on large screens')


      document.querySelector('#menu').classList.add('overlay-visible');

      let elementHeight = document.querySelector('.menu-main').offsetHeight;
      let elementOffsetTop = document.querySelector('.menu-main').offsetTop;
      // let containerWidth = document.querySelector('.overlay-nav-scrolly').offsetWidth;
      let containerHeight = document.querySelector('.overlay-nav-scrolly').offsetHeight;
      let newTop = ((containerHeight - elementHeight) / 2);

      // console.log({elementHeight})
      // console.log({elementOffsetTop})
      // // console.log({containerWidth})
      // console.log({containerHeight})
      // console.log({newTop})

      document.getElementById("menu-main").style.marginTop = newTop + 'px';

      document.querySelector('#menu').classList.remove('overlay-visible');

    }

  };
  
  const data = useStaticQuery(graphql`
    query OverlayNavScrollyFeaturedProjectsQuery {
      contentfulCaseStudyOrderedList(slug: {eq: "featured-projects"}) {
        content {
          client {
            title
          }
          title
          slug
          overlayImage {
            file {
              url
            }
          }
          desktopNavigationImage {
            file {
              url
            }
          }
          mobileNavigationImage {
            file {
              url
            }
          }
          heroImage {
            file {
              url
            }
          }
        }
      }
      allContentfulService(sort: {fields: createdAt, order: ASC}) {
        edges {
          node {
            title
            slug
            overlayImage {
              file {
                url
              }
            }
            image {
              file {
                url
              }
            }
            desktopNavigationImage {
              file {
                url
              }
            }
          }
        }
      }
    }
  `)

  return (
  <>
    <div class="overlay-nav overlay-nav-scrolly" id="menu">
      <div class="overlay-nav-contents">
        <div class="grid-header grid-overlay-nav">
          <div></div>
          <div class="grid-overlay-nav-content">
            {/* <Link to="/" onClick={handleLinkClick}><img class="logo-overlay" src="/images/shift-logo-homepage.png" srcset="/images/shift-logo-homepage.png 1x, /images/shift-logo-homepage.svg 2x, /images/shift-logo-homepage.svg 3x" alt="SHIFT Active Media" /></Link> */}
            <Link to="/" onClick={handleLinkClick}><img class="logo-overlay" src="/images/shift-logo.png" x-srcset="/images/shift-logo-homepage.png 1x, /images/shift-logo-homepage.svg 2x, /images/shift-logo-homepage.svg 3x" alt="SHIFT Active Media" /></Link>
          </div>
          <div></div>
        </div>

        <div class="scrolly-menu">

          <ul class="menu-main" id="menu-main">
            <li class="hidden only-mobile">&nbsp;</li>
            <li class="hidden">&nbsp;</li>
            <li class="hidden">&nbsp;</li>
            <li class="hidden">&nbsp;</li>
            {/* <li class="hidden">&nbsp;</li> */}
            <li class="first"><Link to="/" onClick={handleLinkClick}>Home</Link></li>
            <li><Link to="/about/" onClick={handleLinkClick}>About</Link></li>
            <li><Link to="/the-team/" onClick={handleLinkClick}>Team</Link></li>

            <li class="menu-item-service"><Link to="/our-services/" onClick={handleServiceClick}>Services <img class="chevron" src="/images/chevron-white.svg" /></Link>
              <ul class="menu-sub menu-sub-services" id="sub-menu-service">
                <li><Link to="/our-services/" onClick={handleLinkClick}><u>All Services</u></Link></li>
                {data.allContentfulService.edges.map(({ node }) => {
                  return (
                    <li key={node.slug}>
                      {/* <Link to={`/our-services/#${node.slug}`} data-image={node.desktopNavigationImage ? node.desktopNavigationImage.file.url : node.overlayImage.file.url} onMouseOver={handleLinkMouseOver} onMouseOut={handleLinkMouseOut} onClick={handleLinkClick}>{node.title}</Link> */}
                      {/* {typeof window !== `undefined` && window.location.pathname.startsWith('/our-services') ? 
                      <Link to={`/our-services/#${node.slug}`} data-image={node.desktopNavigationImage ? node.desktopNavigationImage.file.url : node.overlayImage.file.url} data-mobile-image={node.overlayImage.file.url} onMouseOver={handleLinkMouseOver} onMouseOut={handleLinkMouseOut} onClick={handleLinkClick}>{node.title}</Link>
                      :
                      <a href={`/our-services/#:${node.slug}`} data-image={node.desktopNavigationImage ? node.desktopNavigationImage.file.url : node.overlayImage.file.url} data-mobile-image={node.overlayImage.file.url} onMouseOver={handleLinkMouseOver} onMouseOut={handleLinkMouseOut} onClick={handleLinkClick}>{node.title}</a>
                      } */}
                      <Link to={`/our-services/#${node.slug}`} data-image={node.desktopNavigationImage ? node.desktopNavigationImage.file.url : node.overlayImage.file.url} data-mobile-image={node.overlayImage.file.url} onMouseOver={handleLinkMouseOver} onMouseOut={handleLinkMouseOut} onClick={handleLinkClick}>{node.title}</Link>
                    </li>
                  )
                })}
                <li><Link to="/riderresearchhub/" onClick={handleLinkClick}>Rider Research Hub</Link></li>
                <li><Link to="/uplift/" onClick={handleLinkClick}>Uplift</Link></li>
                <li><Link to="" onClick={handleLinkClick}></Link></li>
              </ul>
            </li>

            <li class="menu-item-casestudy"><Link to="/case-studies/" onClick={handleCaseStudyClick}>Case Studies <img class="chevron" src="/images/chevron-white.svg" /></Link>
              <ul class="menu-sub menu-sub-case-studies" id="sub-menu-casestudy">
                <li><Link to="/case-studies/" onClick={handleLinkClick}><u>All Projects</u></Link></li>
                {data.contentfulCaseStudyOrderedList.content.map((node) => {
                  return (
                    <li key={node.slug}>
                      {/* {node.desktopNavigationImage && node.desktopNavigationImage.file &&  */}
                        <Link to={`/case-studies/${node.slug}/`} data-image={node.desktopNavigationImage ? node.desktopNavigationImage.file.url : node.heroImage.file.url} data-mobile-image={node.mobileNavigationImage ? node.mobileNavigationImage.file.url : node.heroImage.file.url} onMouseOver={handleLinkMouseOver} onMouseOut={handleLinkMouseOut} onClick={handleLinkClick}>{node.client.title}: {node.title}</Link>
                      {/* }
                      {!(node.desktopNavigationImage && node.desktopNavigationImage.file) && 
                        <Link to={`/case-studies/${node.slug}/`} data-image={'none'} onMouseOver={handleLinkMouseOver} onMouseOut={handleLinkMouseOut} onClick={handleLinkClick}>{node.client.title}: {node.title}</Link>
                      } */}
                    </li>
                  )
                })}
              </ul>
            </li>
            <li><Link to="/latest-news/" onClick={handleLinkClick}>Latest</Link></li>
            <li><Link to="/careers/" onClick={handleLinkClick}>Careers</Link></li>
            <li class="last"><Link to="/contact/" onClick={handleLinkClick}>Contact</Link></li>
            {/* <li class="hidden">&nbsp;</li> */}
            <li class="only-mobile mobile-nav-footer">
              <div class="phone"><p><a href="tel:+44 1225 448333">+44 (0) 1225 448 333</a></p></div>
              <div class="email"><p><a href="mailto:hello@shiftactivemedia.com">hello@shiftactivemedia.com</a></p></div>
              <div class="social">
                <div class="social-logos">
                  {/* <a href="https://www.facebook.com/shiftactivemedia" target="_blank" rel="noopener noreferrer" class="facebook" title="Facebook"><svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Facebook icon</title><path d="M23.9981 11.9991C23.9981 5.37216 18.626 0 11.9991 0C5.37216 0 0 5.37216 0 11.9991C0 17.9882 4.38789 22.9522 10.1242 23.8524V15.4676H7.07758V11.9991H10.1242V9.35553C10.1242 6.34826 11.9156 4.68714 14.6564 4.68714C15.9692 4.68714 17.3424 4.92149 17.3424 4.92149V7.87439H15.8294C14.3388 7.87439 13.8739 8.79933 13.8739 9.74824V11.9991H17.2018L16.6698 15.4676H13.8739V23.8524C19.6103 22.9522 23.9981 17.9882 23.9981 11.9991Z"/></svg></a> */}
                  <a href="https://www.linkedin.com/company/shift-active-media-ltd/" target="_blank" rel="noopener noreferrer" title="LinkedIn"><svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>LinkedIn icon</title><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg></a>
                  <a href="https://www.instagram.com/shift_active_media/" target="_blank" rel="noopener noreferrer" title="Instagram"><svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Instagram icon</title><path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"/></svg></a>
                </div>
              </div>
            </li>
            <li class="hidden">&nbsp;</li>
            <li class="hidden">&nbsp;</li>
            <li class="hidden">&nbsp;</li>
            <li class="hidden not-mobile">&nbsp;</li>
          </ul>
          
          {/* <div class="fade-top"></div>
          <div class="fade-bottom"></div> */}

        </div>
        

        <div class="overlay-nav-scrolly-footer">
          <div class="grid-header grid-overlay-nav">
            <div></div>
            <div class="grid-overlay-footer overlay-footer">
              <div class="clock-and-address">
                <Clock />
                <p class="larger">Bath</p>
                <p>Monmouth Street Studios, <br />30 Monmouth St, BA1 2AP</p>
              </div>
              <div>
                <p><a href="tel:+44 1225 448333">+44 (0) 1225 448 333</a></p>
              </div>
              <div>
                <p><a href="mailto:hello@shiftactivemedia.com">hello@shiftactivemedia.com</a></p>
              </div>
              <div>
                <div class="social-logos">
                  {/* <a href="https://www.facebook.com/shiftactivemedia" target="_blank" rel="noopener noreferrer" class="facebook" title="Facebook"><svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Facebook icon</title><path d="M23.9981 11.9991C23.9981 5.37216 18.626 0 11.9991 0C5.37216 0 0 5.37216 0 11.9991C0 17.9882 4.38789 22.9522 10.1242 23.8524V15.4676H7.07758V11.9991H10.1242V9.35553C10.1242 6.34826 11.9156 4.68714 14.6564 4.68714C15.9692 4.68714 17.3424 4.92149 17.3424 4.92149V7.87439H15.8294C14.3388 7.87439 13.8739 8.79933 13.8739 9.74824V11.9991H17.2018L16.6698 15.4676H13.8739V23.8524C19.6103 22.9522 23.9981 17.9882 23.9981 11.9991Z"/></svg></a> */}
                  <a href="https://www.linkedin.com/company/shift-active-media-ltd/" target="_blank" rel="noopener noreferrer" title="LinkedIn"><svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>LinkedIn icon</title><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg></a>
                  <a href="https://www.instagram.com/shift_active_media/" target="_blank" rel="noopener noreferrer" title="Instagram"><svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Instagram icon</title><path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"/></svg></a>
                </div>
              </div>
            </div>
            <div></div>
          </div>
        </div>

      </div>
    </div>
  </>
  )
}

export default OverlayNavScrolly
